import React from 'react';
import EmployeePayrollManagement from '../EmployeePayrollManagement';

const AdminPayrollPage = () => {
  return <EmployeePayrollManagement />;
};

export default AdminPayrollPage;
